export const getDollars = (amount = NaN) => {
  return amount.toFixed(2);
};

export const getCents = (amount = NaN) => {
  return +amount.toFixed(2).toString().split('.')[1];
};

export const getSampleAttributeValues = ({ specificationGroup, attributes }) => {
  const attributeValues = [];
  // match the sample attribute value with the attribute value from the parent
  attributes.forEach((attr) => {
    specificationGroup.forEach((specGroup) => {
      const { specifications } = specGroup;
      if (specifications.some(({ specName }) => specName === attr.attributeName)) {
        attributeValues.push(specifications.find(({ specName }) => specName === attr.attributeName).specValue);
      }
    });
  });

  return attributeValues.length ? attributeValues.reduce((acc, curr) => `${acc}, ${curr}`) : null;
};

const sampleSpecNames = [
  'Color',
  'Color/Finish',
  'Finish Type',
  'Cabinet Color'
];

export const getSampleColorSpecValue = (sample, skuNames = []) => {
  const details = sample.specificationGroup?.find((group) => group.specTitle === 'Details');
  const sampleSpecName = details?.specifications?.find((spec) => {
    return sampleSpecNames.includes(spec.specName)
      && (skuNames.length === 0 || skuNames.includes(spec.specValue));
  })?.specName;
  return details
    ?.specifications?.find((spec) => spec.specName === sampleSpecName)
    ?.specValue || '';
};

export const getMetadataAttributeValues = (attributes) => {
  const metadataSpecName = attributes?.find((attr) => {
    return sampleSpecNames.includes(attr.attributeName);
  })?.attributeName;
  return attributes.find((attr) => attr.attributeName === metadataSpecName)
    ?.attributeValues?.map((attrValue) => attrValue.value) || [];
};

export const normalizeImageUrl = (url, size) => {
  const urlRE = /<SIZE>/i;
  return url.replace(urlRE, size);
};

const getMatchingChildItemId = ({ childItems, specificSkuName, excludedItemIds }) => {
  return childItems
    .find((childItem) => {
      return !!childItem.itemId
        && !excludedItemIds.includes(childItem.itemId)
        && childItem.attributeCombination.split('~~').includes(specificSkuName);
    })?.itemId;
};
const getFilteredChildItemIds = ({ childItems, specificSkuNames, excludedItemIds }) => {
  return childItems
    .filter((childItem) => {
      if (!!childItem.itemId && !excludedItemIds.includes(childItem.itemId)) {
        return specificSkuNames.filter((specificSkuName) => {
          return childItem.attributeCombination.split('~~').includes(specificSkuName);
        }).length;
      }
      return false;
    })
    .map((childItem) => childItem.itemId);
};

export const getAnchorItemIds = ({ metadata, specificSkuNames = [], excludedItemIds = [] }) => {
  if (metadata) {
    const childItems = metadata.childItemsLookup || [];
    const attributes = metadata.attributes || [];
    const skuNames = getMetadataAttributeValues(attributes)
      .filter((value) => !specificSkuNames.length || specificSkuNames.includes(value)) || [];
      
    if (childItems.length) {
      if (skuNames.length) {
        const tempItemIds = [];
        skuNames.forEach((skuName) => {
          // eslint-disable-next-line max-len
          const childItemsWithSkuName = getMatchingChildItemId({ childItems, specificSkuName: skuName, excludedItemIds });
          if (childItemsWithSkuName) {
            tempItemIds.push(childItemsWithSkuName);
          } else {
            // eslint-disable-next-line no-console
            console.warn(`could not find child item with SKU name ${skuName}`);
          }
        });
        return tempItemIds;
      }
      return getFilteredChildItemIds({ childItems, specificSkuNames, excludedItemIds });
    }
  }
  return [];
};